import { Loader } from '@googlemaps/js-api-loader';
import * as _ from 'lodash';

let blockMap, map, google, iconUrl, mapZoom, infowindow;
let markers = [];
const debounceDelay = 900;

// eslint-disable-next-line no-undef
const businessLocations = map_block_object.business_locations;
// eslint-disable-next-line no-undef
const ajaxUrl = map_block_object.ajax_url;
// eslint-disable-next-line no-undef
const nonce = map_block_object.nonce;

function initMap() {
	blockMap.forEach((block) => {
		const mapContainer = block.querySelector('#map_canvas');
		const itemLocation = block.querySelectorAll('.item.location');

		// init var map settings;
		iconUrl = mapContainer.dataset.markerIcon;
		mapZoom = +mapContainer.dataset.zoom;

		const geolocations = Array.prototype.slice
			.call(itemLocation)
			.map((item) => ({
				lat: +item?.dataset?.lat ?? null,
				lng: +item?.dataset?.lng ?? null,
				placeId: item?.dataset?.placeId,
			}));

		fetch(`${ajaxUrl}?action=google_api_key&nonce=${nonce}`)
			.then((response) => response.json())
			.then((data) => {
				const loader = new Loader({
					apiKey: data.google_api_key,
				});

				loader.load().then((googleResponse) => {
					google = googleResponse;

					let mapSettings;
					const wilmingtonLat = 39.739071;
					const wilmingtonLng = -75.539787;

					if (geolocations.length > 1) {
						mapSettings = {
							zoom: mapZoom,
							center: new google.maps.LatLng(
								wilmingtonLat,
								wilmingtonLng
							),
						};
					} else {
						mapSettings = {
							zoom: mapZoom,
							position: geolocations[0],
						};
					}

					map = new google.maps.Map(mapContainer, mapSettings);
					setMarkers(geolocations);
					//centerMap();

					// init event
					event();
				});
			})
			.catch(() => {});
	});
}

function event() {
	blockMap.forEach((block) => {
		const inputSearch = block.querySelector('.input-search');
		inputSearch.addEventListener(
			'input',
			_.debounce((e) => {
				onSearchLocation(e.target.value, block);
			}, debounceDelay)
		);
	});

	initMarkerEvent();
	initBusinessLocationItemEvent();
}

function initMarkerEvent() {
	markers.forEach((marker) => {
		marker.addListener('click', () => openMarkerModal(marker));
	});
}

function openMarkerModal(marker) {
	const businessLocation = _.find(businessLocations, {
		location: { place_id: marker.placeId },
	});

	let contentString;

	if (businessLocation) {
		contentString = `<div class="marker-modal">
		<h6>${businessLocation?.post_title}</h6>
		<hr/>
		<p>${businessLocation?.location?.address}</p>
		<p>${businessLocation?.business_hours}</p>
		<p><a href="tel:+${businessLocation?.phone?.replace(/\D/g, '')}">${
			businessLocation?.phone
		}</a></p>
	</div>`;
	} else {
		contentString = `<div class="marker-modal">
		<p>Nothing to display!</p>
		</div>`;
	}

	if (infowindow) infowindow.close();

	infowindow = new google.maps.InfoWindow({
		content: contentString,
	});

	infowindow.open({
		anchor: marker,
		map,
		shouldFocus: false,
	});
}

function initBusinessLocationItemEvent() {
	const eventMapZoom = 15;

	blockMap.forEach((block) => {
		const items = block.querySelectorAll('.item.location');
		items.forEach((item) => {
			item.addEventListener('click', () => {
				map.setZoom(eventMapZoom);

				const position = {
					lat: +item?.dataset?.lat,
					lng: +item?.dataset?.lng,
				};

				map.setCenter(position);
			});
		});
	});
}

function onSearchLocation(searchValue, block) {
	const cloneBusinessLocations = _.cloneDeep(businessLocations);
	const locationContainer = block.querySelector('.location-container');

	const filteredLocations = _.filter(cloneBusinessLocations, (business) => {
		return (
			business?.post_title
				?.toLowerCase()
				.indexOf(searchValue.toLowerCase()) >= 0 ||
			business?.location?.address
				?.toLowerCase()
				.indexOf(searchValue.toLowerCase()) >= 0
		);
	});

	Array.prototype.slice
		.call(locationContainer.children)
		.forEach((element) => element.remove());

	if (filteredLocations.length) {
		filteredLocations.forEach((location) => {
			locationContainer.appendChild(
				getBusinessLocationTemplate(location)
			);
		});
	} else {
		const error = createNode('p', '', 'No search found!');
		locationContainer.appendChild(error);
	}

	const geolocations = filteredLocations.map((filter) => {
		return {
			lat: filter?.location?.lat,
			lng: filter?.location.lng,
			placeId: filter?.location?.place_id,
		};
	});

	deleteMarkers();
	setMarkers(geolocations);
	initMarkerEvent();
	centerMap();
	initBusinessLocationItemEvent();
}

function setMarkers(geolocation) {
	geolocation.forEach((position) => {
		const icon = {
			url: iconUrl,
			scaledSize: new google.maps.Size(40, 40), // scaled size
		};

		if (position.lat && position.lng) {
			const marker = new google.maps.Marker({
				position,
				icon: iconUrl ? icon : null,
				map,
				placeId: position?.placeId,
			});

			markers.push(marker);
			markers[markers.length - 1].setMap(map);
		}
	});
}

// Deletes all markers in the array by removing references to them.
function deleteMarkers() {
	markers.forEach((marker) => {
		marker.setMap(null);
	});
	markers = [];
}

function getBusinessLocationTemplate(businessLocation) {
	const parentNode = createNode('div', 'item location', '', {
		data: {
			lat: businessLocation?.location?.lat,
			lng: businessLocation?.location?.lng,
			'place-id': businessLocation?.location?.place_id,
		},
	});
	const addressParentNode = createNode('address');
	const businessNameNode = createNode(
		'span',
		'business-name',
		businessLocation?.post_title ?? ''
	);
	const addressNode = createNode(
		'span',
		'address',
		businessLocation?.location?.address ?? ''
	);
	const businessHoursNode = createNode(
		'span',
		'business-hours',
		businessLocation?.business_hours ?? ''
	);
	const phoneNode = createNode('span', 'phone');
	const phoneLinkNode = createNode('a', '', businessLocation?.phone ?? '', {
		href: { link: `tel:${businessLocation?.phone}` },
	});
	phoneNode.appendChild(phoneLinkNode);

	addressParentNode.appendChild(addressNode);
	addressParentNode.appendChild(businessHoursNode);
	addressParentNode.appendChild(phoneNode);

	parentNode.appendChild(businessNameNode);
	parentNode.appendChild(addressParentNode);

	return parentNode;
}

function createNode(htmlTag, className = null, text = null, attribute = null) {
	const node = document.createElement(htmlTag);

	if (className) node.className = className;

	if (text) {
		node.innerHTML = text;

		const scripts = node.getElementsByTagName('script');
		let i = scripts.length;
		while (i--) {
			scripts[i].parentNode.removeChild(scripts[i]);
		}
		node.innerHTML = text;
	}

	if (attribute) {
		for (const key in attribute) {
			switch (key) {
				case 'data': {
					node.dataset.lat = attribute[key]?.lat;
					node.dataset.lng = attribute[key]?.lng;
					node.dataset.placeId = attribute[key]['place-id'];
					break;
				}
				case 'href': {
					node.href = attribute[key]?.link;
				}
			}
		}
	}

	return node;
}

function centerMap() {
	// Create map boundaries from all map markers.
	const bounds = new google.maps.LatLngBounds();
	markers.forEach(function (marker) {
		bounds.extend({
			lat: marker.position.lat(),
			lng: marker.position.lng(),
		});
	});

	// Case: Single marker.
	if (markers.length === 1) {
		map.setCenter(bounds.getCenter());

		// Case: Multiple markers.
	} else {
		map.fitBounds(bounds);
	}
}

document.addEventListener('DOMContentLoaded', () => {
	blockMap = document.querySelectorAll('.block-map');
	if (blockMap) initMap();
});
